export function subscribeQuiz() {
    const quiz = document.querySelector('[data-newsletter-quiz]');
    if (!quiz) return;

    const steps = Array.from(quiz.querySelectorAll('[data-newsletter-quiz-step]'));
    const progress = quiz.querySelector('[data-newsletter-quiz-progress]');
    const progressBar = quiz.querySelector('[data-newsletter-quiz-progress-bar]');
    const nextButtons = Array.from(quiz.querySelectorAll('[data-newsletter-quiz-next]'));
    const backButtons = Array.from(quiz.querySelectorAll('[data-newsletter-quiz-back]'));
    let currentStep = 0;

    const showStep = (index, moveFocus = true) => {
        currentStep = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, stepIndex) => {
            const isActive = stepIndex === currentStep;
            step.hidden = !isActive;
            step.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        if (progress) progress.textContent = `Question ${currentStep + 1} of ${steps.length}`;
        if (progressBar) progressBar.style.setProperty('--toptech-newsletter-quiz-progress', `${((currentStep + 1) / steps.length) * 100}%`);
        if (moveFocus) steps[currentStep]?.querySelector('legend, input')?.focus({preventScroll: true});
    };

    quiz.classList.add('is-quiz-ready');
    nextButtons.forEach((button) => button.addEventListener('click', () => showStep(currentStep + 1)));
    backButtons.forEach((button) => button.addEventListener('click', () => showStep(currentStep - 1)));
    quiz.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        input.closest('label')?.classList.toggle('is-selected', input.checked);
    });
    showStep(0, false);
}
